export default __webpack_public_path__ + "static/usabilityTesting1-522ef3406b2557bc6dbcf0ded73eb44a.svg";